import { collection, getCountFromServer, getDocs, query } from 'firebase/firestore';
import { db } from '@/lib/firebase/config';

export async function getInviteCountForUser(userId: string): Promise<number> {
    try {
        const invitesCol = collection(db, `users/${userId}/invites`);
        try {
            const snapshot = await getCountFromServer(invitesCol as any);
            const n = (snapshot as any).data()?.count ?? 0;
            return typeof n === 'number' ? n : 0;
        } catch {
            const qSnap = await getDocs(query(invitesCol));
            return qSnap.size;
        }
    } catch {
        return 0;
    }
}

export async function getInvitesForUser(userId: string): Promise<{ email: string; invitedAt?: Date }[]> {
    const invitesCol = collection(db, `users/${userId}/invites`);
    const snap = await getDocs(query(invitesCol));
    return snap.docs.map(d => {
        const data = d.data() as any;
        return { email: data?.email || d.id, invitedAt: data?.invitedAt?.toDate?.() };
    });
}


